import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { resetStaffUserPassword } from '@containers/Admin/containers/StaffPage/actions';
import { openPopUp } from '@containers/App/containers/PopUp/actions';
import POPUP_TYPES from '@containers/App/containers/PopUp/types';
import Button from '@components/Button';

interface ResetPasswordButtonProps {
  userId: string;
  userEmail?: string;
}

const ResetPasswordButton: React.FC<ResetPasswordButtonProps> = ({ userId, userEmail }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleResetPassword = useCallback(() => {
    if (userId) {
      dispatch(openPopUp(POPUP_TYPES.CONFIRM, {
        onConfirm: (confirm: boolean) => confirm && dispatch(resetStaffUserPassword(userId)),
        titleText: t('Authentication.Password.adminForceResetConfirmTitle', { email: userEmail || '' }),
        bodyText: t('Authentication.Password.adminForceResetConfirmBody', { email: userEmail || '' }),
        confirmText: t('Authentication.Password.resetPassword'),
        cancelText: t('Actions.Instance.cancel'),
        disableBackdrop: true,
      }));
    }
  }, [dispatch, userId, userEmail, t]);

  return (
    <Button color="primary" onClick={handleResetPassword}>
      {t('Authentication.Password.resetPassword')}
    </Button>
  );
};

export default ResetPasswordButton;
